import Switch from './Switch.view';

export default Switch;
